// FE:C8 — help for the Report Studio (namespace "report-studio"). Every claim cites the code that makes it true.
import type { HelpEntry } from '../types'

export const HELP: HelpEntry[] = [
  {
    id: 'report-studio.open',
    title: 'Open the Report Studio',
    body: 'Open the Report Studio from the FuseGrid pane in Excel. It opens in your browser on the workbook\'s current report revision, signed in with your normal FuseGrid account.',
    verified_by: [
      'fusegrid_v2/public/excel-addin/host-operations/report.js:259',
      'fusegrid_v2/src/components/parity-dev/cfo/CfoCoreApp.tsx:39',
      'fusegrid_v2/src/components/parity-dev/cfo/CfoCoreApp.tsx:298',
    ],
  },
  {
    id: 'report-studio.edit_sections',
    title: 'Add, remove, reorder and rename sections',
    body: 'Add a section by picking its type and choosing Add section. Use the arrows to move a section up or down, Remove to drop it, and edit the title in place to rename it. The report period can be changed at the top. Each change is saved as a new report revision.',
    verified_by: [
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:344',
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:208',
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:151',
    ],
  },
  {
    id: 'report-studio.commentary',
    title: 'Write section commentary',
    body: 'Sections that carry commentary show a text box. Type your narrative and choose Save commentary; it is saved as your draft for that section.',
    verified_by: ['fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:325'],
  },
  {
    id: 'report-studio.undo',
    title: 'Undo a change',
    body: 'Undo restores the previous revision of the report as a new revision, so nothing is lost. It is unavailable on the first revision. If the report sheet changed in Excel since you opened the studio, the studio reloads the latest revision and asks you to make your edit again.',
    verified_by: [
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:162',
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:117',
    ],
  },
  {
    id: 'report-studio.ai_edit',
    title: 'Edit the report with AI',
    body: 'Describe the change you want, optionally pick one section, and choose Edit with AI. The AI proposes section and commentary edits, which are applied to the report and saved as a new revision marked as AI-authored. Use Undo if you do not want them.',
    verified_by: [
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:176',
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:185',
    ],
  },
  {
    id: 'report-studio.apply',
    title: 'Apply the report to Excel',
    body: 'Apply to Excel sends the current revision to the workbook. The studio shows "Waiting for approval in Excel" until the workbook owner approves the change in the FuseGrid pane, which then rebuilds the Report sheet from the revision.',
    verified_by: [
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:190',
      'fusegrid_v2/src/components/parity-dev/cfo/ReportStudio.tsx:234',
      'fusegrid_v2/public/excel-addin/host-operations/report.js:133',
    ],
  },
  {
    id: 'report-studio.export',
    title: 'Export the report',
    body: 'Export to PDF or PowerPoint from the FuseGrid pane in Excel after the report is applied. Exports are built from the approved Report sheet snapshot, so the file matches the revision you applied.',
    verified_by: ['fusegrid_v2/public/excel-addin/host-operations/report.js:226'],
  },
]
